/*
 * Chat-Link: Öffnet den Shopify-Inbox-Chat, wenn die Seite mit #chat aufgerufen wird
 * (z. B. https://tortenbild-druckerei.de/#chat) oder ein Link mit href="#chat" angeklickt wird.
 *
 * Shopify bietet dafür keinen offiziellen Link. Das Skript sucht den Chat-Button
 * (<shopify-chat> → verschachtelte Shadow-DOMs → button.activator) und klickt ihn.
 * Ändert Shopify den Aufbau des Widgets, passiert nichts: die Seite lädt normal.
 */
(function () {
  var HASH = '#chat';
  var MAX_WARTEZEIT_MS = 15000;
  var INTERVALL_MS = 300;

  function findeButton(root) {
    if (!root || !root.querySelectorAll) return null;
    var treffer = root.querySelector('button.activator, button[part="activator"]');
    if (treffer) return treffer;
    var alle = root.querySelectorAll('*');
    for (var i = 0; i < alle.length; i++) {
      if (alle[i].shadowRoot) {
        treffer = findeButton(alle[i].shadowRoot);
        if (treffer) return treffer;
      }
    }
    return null;
  }

  function hashEntfernen() {
    if (window.location.hash === HASH && window.history && window.history.replaceState) {
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
    }
  }

  function chatOeffnen() {
    var start = Date.now();
    (function versuch() {
      var chat = document.querySelector('shopify-chat');
      var button = chat && findeButton(chat.shadowRoot);
      if (button) {
        if (button.getAttribute('aria-expanded') !== 'true' && !chat.hasAttribute('open')) {
          button.click();
        }
        hashEntfernen();
        return;
      }
      if (Date.now() - start < MAX_WARTEZEIT_MS) {
        setTimeout(versuch, INTERVALL_MS);
      }
    })();
  }

  if (window.location.hash === HASH) chatOeffnen();

  window.addEventListener('hashchange', function () {
    if (window.location.hash === HASH) chatOeffnen();
  });

  // Links mit #chat auf derselben Seite (z. B. Menüpunkt „Chat“), auch wenn der Hash schon gesetzt ist.
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;
    var url = new URL(link.href, window.location.href);
    if (url.hash !== HASH || url.origin !== window.location.origin || url.pathname !== window.location.pathname) return;
    event.preventDefault();
    chatOeffnen();
  });
})();
